import { Box, BoxProps } from '@chakra-ui/react'
import { withPrefix } from 'gatsby'
import * as React from 'react'

import { LayoutContext, Page, isPageType } from '../context/LayoutContext'
import { useAYDAAudio } from '../hooks/useAYDAAudio'
import Footer from '../components/footer/Footer'
import Intro from '../components/intro/Intro'
import Nav from '../components/nav/Nav'
import SEO from '../components/common/SEO'
import VisualizerSuspense from '../components/visualizer/VisualizerSuspense'

export type LayoutContentProps = BoxProps & {
  children: React.ReactNode
}

const LayoutContent: React.FC<LayoutContentProps> = ({ children }) => {
  const { state, dispatch } = React.useContext(LayoutContext)
  const [currentPage, setCurrentPage] = React.useState<Page | null>(null)
  const [nextPage, setNextPage] = React.useState<Page | null>(null)

  const { playBgm } = useAYDAAudio()
  React.useEffect(() => {
    playBgm('normal')
  }, [])

  React.useEffect(() => {
    if (state.initializeFinished && nextPage) {
      dispatch({
        type: 'startTransition',
        value: { from: null, to: nextPage.path, state: 'visualizaionWillTransition' },
      })
    }
  }, [state.initializeFinished])

  // nextPage 更新
  React.useEffect(() => {
    const to = location.pathname
    const prefix = withPrefix('/')
    const path = '/' + to.replace(prefix, '')
    if (isPageType(path)) {
      if (currentPage?.path !== path || state.transitionType !== null) {
        setNextPage({ path: path, content: children })
      }
    }
  }, [children, setNextPage])

  // ルーターが更新されたら
  React.useEffect(() => {
    if (nextPage) {
      // startTransition(nextPage)
      const prevTransition = state.transitionType
      if (prevTransition === null) {
        // 遷移中でない場合
        if (currentPage) {
          // 最初以外の表示
          dispatch({
            type: 'startTransition',
            value: { from: currentPage.path, to: nextPage.path, state: 'pageWillDisappear' },
          })
        }
      } else {
        // 遷移中だったら
        if (currentPage && prevTransition.state === 'pageWillAppear') {
          // 次のページ表示中だったら
          dispatch({
            type: 'startTransition',
            value: { from: currentPage.path, to: nextPage.path, state: 'pageWillDisappear' },
          })
        } else {
          // to だけ変わる
          dispatch({ type: 'changeTransitionTo', value: nextPage.path })
        }
      }
    }
  }, [nextPage])

  React.useEffect(() => {
    const transition = state.transitionType
    if (transition) {
      switch (transition.state) {
        case 'pageDidDisappear':
          // ページの非表示完了
          dispatch({ type: 'updateTransition', value: 'visualizaionWillTransition' })
          break
        case 'visualizaionDidTransition':
          // GLトランジション終了
          setCurrentPage(nextPage)
          setNextPage(null)
          dispatch({ type: 'updateTransition', value: 'pageWillAppear' })
          break
        case 'pageDidAppear':
          // 遷移終了
          dispatch({ type: 'clearTransition' })
          break
        default:
          break
      }
    }
  }, [state.transitionType])

  return (
    <>
      <SEO />
      <Box pos="relative" w="100%" h="100%">
        <Nav zIndex="4" />
        <VisualizerSuspense zIndex="0" />
        <Box pos="absolute" top="0" left="0" w="100%" zIndex="1">
          {currentPage && currentPage.content}
        </Box>
        <Intro zIndex="3" />
        <Footer zIndex="2" />
      </Box>
    </>
  )
}

export default LayoutContent
